import Col from './responsive/Col';
import Row from './responsive/Row';

export default {
  Row,
  Col,
};
